import { render, staticRenderFns } from "./TemplateCard.vue?vue&type=template&id=0204d746&"
import script from "./TemplateCard.vue?vue&type=script&lang=ts&"
export * from "./TemplateCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports